import { render, staticRenderFns } from "./currency-add.vue?vue&type=template&id=4dc9a306&"
import script from "./currency-add.vue?vue&type=script&lang=js&"
export * from "./currency-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports